import useStores from './use-stores';
export default function useApolloClient() {
    var apolloClient = useStores().apolloClient;
    return apolloClient;
}
